import { Box, Title, Divider } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

import ImagesForm from "common/admin/forms/ImagesForm";
import type { Quiz } from "quiz/types/quiz.model";

export function QuizImagesFormInput({
  form,
}: {
  form: UseFormReturnType<Omit<Quiz, "id">>;
}) {
  return (
    <>
      <Box>
        <Title order={4}>All Devices</Title>
        <ImagesForm
          form={form}
          fields={[
            ["waitingLogo", "Quiz Loading Image"],
            ["gameOverLogo", "End Game Image"],
            ["questionLogo", "Quiz Logo during Game"],
            ["winnerLogo", "Winnner Logo"],
          ]}
        />
      </Box>
      <br />
      <Divider my="sm" />
      <br />
      <Box>
        <Title order={4}>Screen</Title>
        <ImagesForm
          form={form}
          fields={[
            ["screenBackground", "Background"],
            ["screenBackgroundLeft", "Screen Background Left"],
            ["screenAnimatedLogo", "Animated Image during Quiz"],
          ]}
        />
      </Box>
      <br />
      <Divider my="sm" />
      <br />
      <Box>
        <Title order={4}>Mobile</Title>
        <ImagesForm
          form={form}
          fields={[
            ["playBackground", "Background"],
            ["registerLogo", "Register screen background"],
          ]}
        />
      </Box>
    </>
  );
}
